import { devlog } from "../../logic/utils.ts";
import styleText from './as-viewport.css?raw';

export class AsViewport extends HTMLElement {
  private configuratorComp: any;
  
  private paramateVp: any;
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  constructor() {
    super();
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.adoptedStyleSheets = [
      ...shadow.adoptedStyleSheets,
      AsViewport.sheet
    ];
    shadow.innerHTML = `<slot></slot>`;
    // Listen for as-cfgr-comp-ready event
    document.addEventListener('as-cfgr-comp-ready', this.handleConfiguratorCreated);

    // Request configurator if not available
    if (!this.configuratorComp) {
      // this.requestConfigurator();
    }
  }
  
  connectedCallback() {
    // Start observing the component's child nodes

    window.addEventListener('configurator-initialized', (event: CustomEvent) => {
      // Get the viewport from the configurator event
      this.paramateVp = event.detail.configurator.viewPort;
      // devlog("AsViewport: Got viewport from configurator-initialized event");
      
      this.paramateVp.updateViewport();
      window.addEventListener('resize',(ev)=>{
        this.paramateVp.updateViewport();
      })

      setTimeout(() => {
        this.dispatchCameraUpdate();
      }, 100);

      const userOnAnimCallback = this.paramateVp.onModelAnimationFrame;
      this.paramateVp.onModelAnimationFrame = () => {
        // devlog("VIEWPORT: Model animation frame");
        userOnAnimCallback?.();
        this.dispatchCameraUpdate();
      }
      this.dispatchEvent(new CustomEvent('as-viewport-ready', {
        detail: { viewport: this.paramateVp },
        bubbles: true,
        composed: true
      }));

      window.dispatchEvent(new CustomEvent('as-viewport-class', {
        detail: {
          vpComponent:this,
          viewport:this.paramateVp
        }
      }));
    });

    // Listen for as-get-paramate-vp events and respond with viewport instance if available
    window.addEventListener('as-get-paramate-vp', this.handleGetParamateVp);
  }

  disconnectedCallback(): void {
    // Clean up the observer when the element is disconnected
    window.removeEventListener('as-get-paramate-vp', this.handleGetParamateVp);
  }

  /**
   * Handle as-get-paramate-vp event
   */
  private handleGetParamateVp = (event: CustomEvent): void => {
   devlog("AsViewport: Handling as-get-paramate-vp event, have viewport:", !!this.paramateVp);
    if (this.paramateVp) {
      event.detail.resolve(this.paramateVp);
    }
  }

  /**
   * Handle configurator created event
   */
  private handleConfiguratorCreated = (event: CustomEvent<{ sender?: any }>): void => {
    // devlog("Configurator created event received");
    this.configuratorComp = event.detail?.sender;
    if (!this.configuratorComp) {
      console.warn('No configurator found in as-cfgr-comp-ready event');
      return;
    }
  }

  /**
   * Dispatches camera update event to all children
   */
  private dispatchCameraUpdate(): void {
    const cam = this.paramateVp?.getCameraParams?.();
    if (cam) {
      // Dispatch to specific axis display component
      const axisDisplay = this.querySelector('as-axis-display');
      if (axisDisplay) {
        axisDisplay.dispatchEvent(new CustomEvent('as-viewport-camera-update', {
          detail: { cam }
        }));
      }

      // Also dispatch bubbling event for any other interested components
      window.dispatchEvent(new CustomEvent('as-viewport-camera-update', {
        detail: { cam },
        bubbles: true,
        composed: true
      }));
    }
  }
}

// Check if the element is already defined before registering it
if (!customElements.get('as-viewport')) {
  customElements.define('as-viewport', AsViewport);
} else {
  console.warn("as-viewport already defined");
}


